<section>
  <div class="container d-flex align-items-center justify-content-center mt-5">
    <div class="card card-fixed" style="z-index: 999">
      <div class="d-flex align-items-center justify-content-center">
        <img
          alt="logoBimbo"
          src="../../../../../assets/Icons/logo.svg"
          width="350px"
          class="m-0 p-0" />
      </div>
      <hr />
      <div class="card-body text-center">
        <h1 class="title-blue-h1-cap">
          Lo siento, parece que aún no tienes acceso.
        </h1>
        <h3 class="title-blue-bimbo-cap">
          Por favor, consulta al administrador del sistema para generar tu
          registro. ¡Gracias!
        </h3>
        <p>
          <button class="btn btn-primario" (click)="onClick()">
            <span> Regresar </span>
          </button>
        </p>
      </div>
    </div>
  </div>
  <div class="wave wave1"></div>
  <div class="wave wave2"></div>
  <div class="wave wave3"></div>
</section>
